// app/composables/pages/pagination.ts

import type { Ref } from "@vue/reactivity";
import { useRouteQuery } from "~/app/composables/routeQuery";

interface UsePagination {
  currentPage: Ref<number>;
  itemsPerPage: number;
  pageCount: number;
  resetPage: () => void;
}

export const usePagination = (): UsePagination => {
  const route = useRoute();

  const pageCount = 3; // Amount of visible pages
  const itemsPerPage = 10;

  const routePage = route.query.page;
  const initialPage = routePage ? parseInt(routePage.toString(), 10) || 1 : 1;

  const currentPage = ref<number>(initialPage);

  const resetPage = () => {
    const { deleteQuery } = useRouteQuery();

    currentPage.value = 1;
    deleteQuery("page");
  };

  return {
    currentPage,
    pageCount,
    itemsPerPage,
    resetPage,
  };
};
